import React from 'react';
import { useSelector } from 'react-redux';
import './index.scss';

const Loader = () => {
    const showLoader = useSelector((state) => state.ctrl)   
    const bulkUpdTagStatus = useSelector((state) => state.project.bulkUpdTagStatus)
    const reportHub = useSelector((state) => state.project.reportHub)
    const isBulkTagUpdate = bulkUpdTagStatus == 'LOADING' ? true : false
    const isReportHub = reportHub == 'LOADING' ? true : false
    
    //console.log('isBulkTagUpdate',isBulkTagUpdate)
    if(showLoader.loading && !isBulkTagUpdate && !isReportHub){
        return(
            <div className = "spinner-block" />
        )
    }
    else if(isBulkTagUpdate){
        return (
            <div className="spinner-blockout">
             <div className="spinner-blok" >  
             <div  className="spinner-content">
              <h4>Please wait while the package page is being loaded...</h4>
             </div>
            </div> 
            </div>
          );
    }
    else if(isReportHub){
        return (
            <div className="spinner-blockout">
             <div className="spinner-blok" >  
             <div  className="spinner-content">
              <h4>Please wait while your request is being processed...</h4>
             </div>
            </div> 
            </div>
          );
    }
    else
    return null;

}

export default Loader;